var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[(_vm.value)?_c('portal-target',{attrs:{"name":`table-toolbar-${_vm.value.id}`}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }